// authProvider.js
import api from "./useApi";
import Cookies from 'universal-cookie';
import { addDays, addMinutes } from "date-fns";
import { removeKeys } from "./reformatPermissions";
import axios from "axios";

const cookies = new Cookies();

const getStoredUser = () => {
    try {
        return JSON.parse(localStorage.getItem('user'));
    } catch (e) {
        console.error('Failed to parse stored user data:', e);
        return null;
    }
};

const AuthProvider = {
    user: getStoredUser(),
    isAuthenticated: !!getStoredUser(),
    id: localStorage.getItem('user_id') || null,

    /**
     * Sign in the user.
     * @param {FormData} formData - The form data containing email and password.
     */
    async signin(formData) {
        try {
            const response = await axios.post(`/api/login/user/`, formData, {
                headers: {
                    "Content-Type": 'multipart/form-data'
                }
            });
            if (response.status === 200) {
                try {
                    const { access, refresh } = response.data;
                    const refreshExpires = addDays(new Date(), 1);
                    cookies.set('refresh', refresh, { sameSite: 'lax', expires: refreshExpires, path: '/' });

                    const accessExpires = addMinutes(new Date(), 5);
                    cookies.set('access', access, { sameSite: 'lax', expires: accessExpires, path: '/' });
                    const user = (await api.get('/api/user/profile/')).data;
                    this.user = removeKeys(user, ['password']);
                    localStorage.setItem('user', JSON.stringify(this.user));
                } catch (e) {
                    localStorage.removeItem('user');
                    console.error('Error retrieving user details:', e);
                    throw e;
                }
                this.isAuthenticated = true;


            } else {
                throw new Error('Login failed');
            }
        } catch (error) {
            console.error('Error during signin:', error);
            this.isAuthenticated = false;
            this.user = null;
            localStorage.removeItem('user');
            throw error;
        }
    },
    async getUserDetails() {
        if (this.profilePromise) return this.profilePromise;
        this.profilePromise = (async () => {
        try {
            const response = (await api.get('/api/user/profile/')).data;
            this.user = removeKeys(response, ['password', 'password_hash']);
            localStorage.setItem('user', JSON.stringify(this.user));
            return this.user;
        }
        catch (e) {
            this.profilePromise = null;
            if (e.response?.status === 401) return null;
            throw e;
        }
        })();
        return this.profilePromise;
    },
    /**
     * Sign out the user.
     */
    async signout() {
        //console.log('Signout request called.');

        const refreshToken = cookies.get('refresh');
        cookies.remove('access', { path: '/' });
        cookies.remove('refresh', { path: '/' });
        this.isAuthenticated = false;
        this.user = null;
        this.profilePromise = null;
        localStorage.removeItem('user');

        if (refreshToken) {
            try {
                await api.post('/api/logout/user/');
            } catch (error) {
                console.error('Token already expired, blocked, or incorrect:', error);
            }
        }
    },

    /**
     * Check if the user is authenticated.
     * @returns {Promise<boolean>} - True if the user is authenticated, false otherwise.
     */
    async checkAuth() {
        const refreshToken = cookies.get('refresh');
        if (!refreshToken) {
            await this.signout();
            return false;
        } else {
            this.isAuthenticated = true;
            return true;
        }
    },
};

export default AuthProvider;
